// extracted by mini-css-extract-plugin
export default {"lazyLoading":"LazyLoading_lazyLoading__bQasK"};